






















import { Component, Prop, Vue } from 'vue-property-decorator';
import PageApiAgent,{ PageList } from './services/page-api-agent';
import TranslationApiAgent from './services/translation-api-agent';
import AuthApiAgent from './services/auth-api-agent';

// @ts-ignore
@Component
export default class App extends Vue {

  private pages: PageList[] = [];

  private title: string = this.translationApiAgent.get('title');
  private home: string = this.translationApiAgent.get('home');
  private gallery: string = this.translationApiAgent.get('gallery');
  private programs: string = this.translationApiAgent.get('programs');
  private about: string = this.translationApiAgent.get('about');
  private contact: string = this.translationApiAgent.get('contact');
  private menu: string = this.translationApiAgent.get('menu');

  constructor(
    private translationApiAgent = TranslationApiAgent,
    private authApiAgent = AuthApiAgent) {
    super();
  }

  mounted () {
    document.title = this.translationApiAgent.get('title');
    PageApiAgent.getList().then(pages => this.pages = pages);
  }

  get isAdmin() {
    return this.authApiAgent.isAdmin;
  }
}
